<ng-container *ngIf="content && hasContent">
  <div fxLayout="column" fxLayoutGap="20px">
    <h2 class="text-center">{{ label }}</h2>
    <ag-clcd-study-programs
      *ngIf="content.studyProgram || content.age"
      [studyProgram]="content.studyProgram"
      [age]="content.age"
    ></ag-clcd-study-programs>
    <ag-clcd-awards *ngIf="content.awards" [awards]="content.awards"></ag-clcd-awards>
    <ag-clcd-reviews *ngIf="content.reviews" [reviews]="content.reviews"></ag-clcd-reviews>
    <ag-clcd-books-like-this
      *ngIf="carouselItems.length > 0"
      [carouselItems]="carouselItems"
    ></ag-clcd-books-like-this>
  </div>
</ng-container>
